import { render, staticRenderFns } from "./OrderTypeChooserDialog.vue?vue&type=template&id=ab4ed608"
import script from "./OrderTypeChooserDialog.vue?vue&type=script&lang=ts"
export * from "./OrderTypeChooserDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports